<template>
    <div data-test-view="badge-update-delete">
        <p data-test-id="badge-delete-text">
            <l-text
                :text="$t(`adminSettings.feedbackCustomBadgesDisableText`, { name: badge.name })"
            />
        </p>

        <!-- Error -->
        <l-text-alert
            v-show="error"
            type="danger"
            :text="$t(`adminSettings.feedbackCustomBadgesDisableErrorText`)"
            data-test-id="badge-delete-error"
        />
        <!--/Error -->

        <hr />

        <div class="footer">
            <button
                class="btn btn-primary"
                type="button"
                data-test-id="badge-delete-cancel"
                @click="cancel()"
            >
                {{ $t(`adminSettings.feedbackCustomBadgesDisableCancelBtn`) }}
            </button>
            <button
                class="btn btn-primary btn-raised"
                type="button"
                data-test-id="badge-delete-confirm"
                @click="deleteBadge()"
            >
                {{ $t(`adminSettings.feedbackCustomBadgesDisableConfirmBtn`) }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LTextAlert from "@/components/LTextAlert";
import LText from "@/components/LText";

export default {
    components: {
        LText,
        LTextAlert,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            badge: {},
            error: false,
            errorMessage: "",
        };
    },
    computed: {
        ...mapGetters({
            getBadge: "feedback/badges/details",
        }),
    },
    created() {
        this.badge = this.getBadge({ id: this.id });
    },
    methods: {
        cancel() {
            this.$router.push("/team/settings/feedback");
        },
        deleteBadge() {
            this.error = false;

            this.$store
                .dispatch({
                    type: "feedback/badges/delete",
                    payload: {
                        id: this.id,
                    },
                })
                .then(() => {
                    this.$router.push("/team/settings/feedback");
                })
                .catch(() => {
                    this.error = true;
                });
        },
    },
};
</script>

<style scoped></style>
